<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :close-on-click="close_on_click"
    :min-width="min_width"
    :max-width="max_width"
    offset-y
    :left="left"
    :top="top"
    :right="right"
    :bottom="bottom"
  >
    <template #activator="{ on: menuOn, attrs: menuAttrs }">
      <v-tooltip bottom open-delay="500" :open-on-hover="desativar_remocao">
        <template #activator="{ on: tipOn, attrs: tipAttrs }">
          <span
            style="display:inline-flex"
            v-bind="{ ...menuAttrs, ...tipAttrs }"
            v-on="{
              ...tipOn,
              ...menuOn,
              click: (e) => {
                if (desativar_remocao) {
                  e.preventDefault()
                  e.stopPropagation()
                  return
                }
                menuOn.click && menuOn.click(e)
              }
            }"
          >
            <v-btn
              :icon="!txt_ativador"
              :text="!!txt_ativador"
              :disabled="desativar_remocao"
            >
              <v-icon :color="cor_icone">{{ icone_personalizado }}</v-icon>
              {{ txt_ativador }}
            </v-btn>
          </span>
        </template>

        <span v-if="desativar_remocao">Não é possível remover este item, pois ele já está vinculado.</span>
        <!--        <span v-else>teste de mensagem 22</span>-->
      </v-tooltip>
    </template>

    <v-card class="bra-20">
      <v-card-title class="font-14 py-2 pr-2">
        <span>{{ texto_titulo }}</span>

        <v-spacer />

        <v-btn icon small @click="fechar();">
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="py-4">
        <slot />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text small
          @click="confirmar()"
        >
          {{ texto_botao_aceitar }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "DeletarLista",
  props: {
    top: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    icone_personalizado: {
      type: String,
      default: 'prop:icone_personalizado'
    },
    texto_titulo: {
      type: String,
      default: 'prop:texto_titulo'
    },
    texto_botao_voltar: {
      type: String,
      default: 'Cancelar'
    },
    texto_botao_aceitar: {
      type: String,
      default: 'Salvar'
    },
    min_width: {
      type: [Number, String],
      default: 250
    },
    max_width: {
      type: [Number, String],
      default: 250
    },
    cor_icone: {
      type: String,
      default: ''
    },
    txt_ativador: String,
    close_on_click: {
      type: Boolean,
      default: false
    },
    desativar_remocao: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    }
  },
  methods: {
    fechar() {
      this.menu = false;
    },
    confirmar() {
      this.fechar();
      this.$emit('confirmar-menu');
    }
  },
  watch: {
    menu(val) {
      if (!val) this.$emit('fechado')
    }
  },
}
</script>
<style scoped>

</style>
